/**
 * @generated SignedSource<<fe3e6beb95cbedf73c66c617a1002397>>
 * @relayHash c9351072966dcc87a9b68886d355a3fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5cd830dde491b8a12d8e22ef282c1c20e1aded042de2b09fada0c205de9cd813

import type { ConcreteRequest } from 'relay-runtime';
export type HomeRecentAgentSessionsSubscription$variables = {
  accountId: string;
  cloudId: string;
  workspaceAri: string;
};
export type HomeRecentAgentSessionsSubscription$data = {
  readonly convoai_onInboxSessionChanged: {
    readonly sessionId: string;
  } | null;
};
export type HomeRecentAgentSessionsSubscription = {
  response: HomeRecentAgentSessionsSubscription$data;
  variables: HomeRecentAgentSessionsSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceAri"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
      },
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "workspaceAri",
        "variableName": "workspaceAri"
      }
    ],
    "concreteType": "ConvoAiInboxSessionChanged",
    "kind": "LinkedField",
    "name": "convoai_onInboxSessionChanged",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "sessionId"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "HomeRecentAgentSessionsSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HomeRecentAgentSessionsSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c9351072966dcc87a9b68886d355a3fb",
    "id": "5cd830dde491b8a12d8e22ef282c1c20e1aded042de2b09fada0c205de9cd813",
    "metadata": {},
    "name": "HomeRecentAgentSessionsSubscription",
    "operationKind": "subscription",
    "text": "subscription HomeRecentAgentSessionsSubscription($accountId:String!,$cloudId:ID!,$workspaceAri:ID!){convoai_onInboxSessionChanged(accountId:$accountId,cloudId:$cloudId,workspaceAri:$workspaceAri)@optIn(to:\"ConvoAiInboxSessionChanged\"){sessionId}}"
  }
};
})();

(node as any).hash = "6ad85edfea368dcc0a351fba1b2dfab9";

export default node;
